import {Component, computed, input, output} from '@angular/core';
import {TypeOption} from '@app/models';
import {resultA, resultB, resultC} from '@app/data/results.data';
import {Result} from '@app/models/result.model';
import {AccentComponent} from '@app/components/accent/accent.component';
import {Button} from 'primeng/button';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-result',
  imports: [
    AccentComponent,
    Button,
    RouterLink
  ],
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
})
export class ResultComponent {
  public result = input.required<TypeOption>();
  public home = output<void>();

  private results = [
    resultA,
    resultB,
    resultC
  ]

  protected resultDetails = computed<Result>(() => {
    const resultDetails = this.results.find(value => value.type === this.result());
    return resultDetails || resultA;
  });

}
